import React from 'react';
import { m } from 'framer-motion';
import { styled } from '@linaria/react';
import { COLORS, typographyStyles } from '@livecommerce/design-system';

const { getBodyText } = typographyStyles;

const Content = styled.div`
  margin: 5px;
  border-radius: 2px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Label = styled.div`
  color: ${COLORS.light_700};
  ${getBodyText(12, 400)};
  line-height: 18px;
`;

const HeaderItem = (props) => {
  const { children, label, ...rest } = props;
  return (
    <m.div layout="position" {...rest}>
      <Content>
        {children}
        <Label>{label}</Label>
      </Content>
    </m.div>
  );
};

export default HeaderItem;
